__turbopack_context__.v({
  "sidebar-teams-tab-container": "course-sidebar-tabs-container-module-scss-module__7Q0RYq__sidebar-teams-tab-container",
});
